import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["data-testid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "gridRef",
    class: "year-grid",
    "data-testid": `${_ctx.testid}-custom-picker-year`
  }, [
    _createVNode(_component_v_list, { class: "year-list-items" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allowedYears, (year) => {
          return (_openBlock(), _createBlock(_component_v_list_item, {
            key: year,
            class: _normalizeClass(["year-list-item", {
          selected: year === _ctx.selected,
          current: year === _ctx.currentYear,
        }]),
            onClick: ($event: any) => (_ctx.$emit('select', year))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(year), 1)
            ]),
            _: 2
          }, 1032, ["class", "onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ], 8, _hoisted_1))
}